(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6525],{

/***/ 26333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ customers; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/api/routes/customers/queries/index.ts + 4 modules
var queries = __webpack_require__(34157);
// EXTERNAL MODULE: ../../libs/utils/useNextPageTrigger/index.ts + 1 modules
var useNextPageTrigger = __webpack_require__(78299);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/utils/useContentfulImage/useContentfulImage.ts


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var getImageUrl = function getImageUrl(url, params) {
  var queryParameters = new URLSearchParams(Object.entries(params));
  return "".concat(url, "?").concat(queryParameters);
};

var emptyArray = [];
/**
 * A hook to generate the image urls for the different image sizes
 * @param url - The path to the image
 * @param options.width - The width of the image
 * @param options.height - The height of the image
 * @param options.ext - The extension of the image
 * @param options.additionalImages - An array of additional images to generate
 * @returns The array of generated image urls
 */

var useContentfulImage = function useContentfulImage(url, options) {
  var width = options.width,
      height = options.height,
      _options$additionalIm = options.additionalImages,
      additionalImages = _options$additionalIm === void 0 ? emptyArray : _options$additionalIm;
  return (0,react.useMemo)(function () {
    if (!url) {
      return null;
    }

    var generatedImagesUrls = [getImageUrl(url, {
      w: width,
      h: height,
      fm: options.ext
    })];

    for (var i = 0; i < additionalImages.length; i++) {
      var _additionalImages$i = additionalImages[i],
          ext = _additionalImages$i.ext,
          multiplier = _additionalImages$i.multiplier;
      var dimensionParams = multiplier ? {
        w: width * multiplier,
        h: height * multiplier
      } : {};
      var extParam = ext ? {
        fm: ext
      } : {};
      var newUrl = getImageUrl(url, _objectSpread(_objectSpread({}, extParam), dimensionParams));
      generatedImagesUrls.push(newUrl);
    }

    return generatedImagesUrls;
  }, [url, width, height, emptyArray]);
};

/* harmony default export */ var useContentfulImage_useContentfulImage = (useContentfulImage);
;// CONCATENATED MODULE: ../../libs/utils/useContentfulImage/index.ts

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/CustomerCard/CustomerCard.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var CustomerCard = function CustomerCard(_ref) {
  var href = _ref.href,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      children: children
    })
  });
};

var Content = function Content(_ref2) {
  var children = _ref2.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
    variant: "h4",
    children: children
  });
};

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e15z8ekz4"
} : 0)("margin-top:10px;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.brand.darkAcai[800];
}, ";", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;}" + ( true ? "" : 0));

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15z8ekz3"
} : 0)("display:grid;gap:25px;grid-template-rows:30px max-content auto;min-height:360px;height:100%;padding:24px;background:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.neutrals.white[100];
}, ";box-shadow:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.shadows[1];
}, ";border-radius:10px 10px 64px 10px;text-decoration:none;transition:box-shadow 0.3s ease;" + ( true ? "" : 0));

var logoImageFormats = {
  ext: "png",
  height: 30,
  width: 300
};
var Logo = function Logo(_ref7) {
  var _useContentfulImage;

  var src = _ref7.src,
      _ref7$alt = _ref7.alt,
      alt = _ref7$alt === void 0 ? "" : _ref7$alt,
      children = _ref7.children;

  var _ref8 = (_useContentfulImage = useContentfulImage_useContentfulImage(src, logoImageFormats)) !== null && _useContentfulImage !== void 0 ? _useContentfulImage : [],
      _ref9 = (0,slicedToArray/* default */.Z)(_ref8, 1),
      image = _ref9[0];

  return image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoImage, {
    loader: function loader() {
      return image;
    },
    src: image,
    alt: alt,
    height: 30,
    width: 300
  }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoWrapper, {
    children: children
  });
};

var LogoImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e15z8ekz2"
} : 0)( true ? {
  name: "gcll7d",
  styles: "max-height:30px;width:auto;height:auto;object-position:left bottom;object-fit:contain;margin:0;height:100%"
} : 0);

var LogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15z8ekz1"
} : 0)( true ? {
  name: "1fmxwhk",
  styles: "max-height:30px"
} : 0);

var CustomerCard_Footer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15z8ekz0"
} : 0)( true ? {
  name: "eq7f8j",
  styles: "display:flex;align-items:flex-end"
} : 0);
/* harmony default export */ var CustomerCard_CustomerCard = (CustomerCard);
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/CustomerCardsGrid/CustomerCardsGrid.tsx


function CustomerCardsGrid_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var CustomerCardsGrid = function CustomerCardsGrid(_ref7) {
  var integrations = _ref7.integrations,
      nextPageTrigger = _ref7.nextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomerCardsGrid_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGrid, {
      children: integrations.map(function (item, i) {
        var _item$company;

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItem, {
          area: i % 8,
          integration: item
        }, ((_item$company = item.company) !== null && _item$company !== void 0 ? _item$company : "") + i);
      })
    }), integrations.length === 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      centered: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        tag: "h4",
        variant: "h4",
        children: "Sorry, no results found."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
        tag: "p",
        variant: "pMedium",
        children: "Please try selecting different filters."
      })]
    }), nextPageTrigger]
  });
};

var GridItem = function GridItem(_ref8) {
  var area = _ref8.area,
      integration = _ref8.integration;

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setIsHover = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItemWrapper, {
    area: area,
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CustomerCard_CustomerCard, {
      href: "/customers/".concat(integration.slug, "/"),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, {
        src: integration.logoUrl
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: integration.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerCard_Footer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          size: "small",
          variant: "mono",
          hover: isHover,
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Read their story"
        })
      })]
    })
  });
};

var CustomerCardsGrid_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e754n0l2"
} : 0)( true ? {
  name: "ru8pja",
  styles: "display:grid;padding:80px 24px 160px 24px;gap:32px"
} : 0);

var CardsGrid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e754n0l1"
} : 0)("display:grid;gap:32px;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:repeat(2, 1fr);}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("lg");
}, "{grid-template-columns:repeat(6, 1fr);}" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1tkue4o",
  styles: "grid-column:3/7"
} : 0;

var _ref2 =  true ? {
  name: "1efuq62",
  styles: "grid-column:1/3"
} : 0;

var _ref3 =  true ? {
  name: "17k5ase",
  styles: "grid-column:5/7"
} : 0;

var _ref4 =  true ? {
  name: "1xtwnfq",
  styles: "grid-column:1/5"
} : 0;

var _ref5 =  true ? {
  name: "6rh8zf",
  styles: "grid-column:4/7"
} : 0;

var _ref6 =  true ? {
  name: "1wygoze",
  styles: "grid-column:1/4"
} : 0;

var GridItemWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e754n0l0"
} : 0)(function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.up("lg");
}, "{", function (_ref12) {
  var area = _ref12.area;
  return (area === 0 || area === 4) && _ref6;
}, " ", function (_ref13) {
  var area = _ref13.area;
  return (area === 1 || area === 5) && _ref5;
}, " ", function (_ref14) {
  var area = _ref14.area;
  return area === 2 && _ref4;
}, " ", function (_ref15) {
  var area = _ref15.area;
  return area === 3 && _ref3;
}, " ", function (_ref16) {
  var area = _ref16.area;
  return area === 6 && _ref2;
}, " ", function (_ref17) {
  var area = _ref17.area;
  return area === 7 && _ref;
}, ";}" + ( true ? "" : 0));

/* harmony default export */ var CustomerCardsGrid_CustomerCardsGrid = (CustomerCardsGrid);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CustomerCard/index.ts + 2 modules
var recipes_CustomerCard = __webpack_require__(49976);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Hero/imageFormats.ts
var imageFormats_logoImageFormats = {
  width: 130,
  height: 30,
  ext: "png"
};
var featuredImageFormats = {
  width: 888,
  height: 888,
  ext: "jpg"
};
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Hero/List.tsx



function List_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var List = function List(_ref) {
  var data = _ref.data;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List_Wrapper, {
    children: data.map(function (_ref2, i) {
      var featuredImage = _ref2.featuredImage,
          featuredLogo = _ref2.featuredLogo,
          slug = _ref2.slug;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
        slug: slug,
        featuredLogo: featuredLogo,
        featuredImage: featuredImage,
        index: i
      }, i);
    })
  });
};

var Item = function Item(_ref3) {
  var _featuredLogo$fields, _useContentfulImage, _featuredImage$fields, _useContentfulImage2;

  var slug = _ref3.slug,
      featuredImage = _ref3.featuredImage,
      featuredLogo = _ref3.featuredLogo,
      index = _ref3.index;
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(false),
      isHover = _useState[0],
      setIsHover = _useState[1];

  var logoFile = featuredLogo === null || featuredLogo === void 0 ? void 0 : (_featuredLogo$fields = featuredLogo.fields) === null || _featuredLogo$fields === void 0 ? void 0 : _featuredLogo$fields.file;

  var _ref4 = (_useContentfulImage = useContentfulImage_useContentfulImage(logoFile === null || logoFile === void 0 ? void 0 : logoFile.url, imageFormats_logoImageFormats)) !== null && _useContentfulImage !== void 0 ? _useContentfulImage : [],
      _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 1),
      logoOptimizedUrl = _ref5[0];

  var imageFile = featuredImage === null || featuredImage === void 0 ? void 0 : (_featuredImage$fields = featuredImage.fields) === null || _featuredImage$fields === void 0 ? void 0 : _featuredImage$fields.file;

  var _ref6 = (_useContentfulImage2 = useContentfulImage_useContentfulImage(imageFile === null || imageFile === void 0 ? void 0 : imageFile.url, featuredImageFormats)) !== null && _useContentfulImage2 !== void 0 ? _useContentfulImage2 : [],
      _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 1),
      featuredImageOptimizedUrl = _ref7[0];

  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var buttonAppearance = appearance === "twilioLight" ? "dark" : undefined;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
    href: (0,getAbsoluteUrl/* default */.Z)("/customers/".concat(slug, "/"), pageConfig),
    img: featuredImageOptimizedUrl,
    hoverable: true,
    area: "item".concat(index),
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_CustomerCard/* Row */.X, {
      children: logoOptimizedUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List_Logo, {
        loader: function loader() {
          return logoOptimizedUrl;
        },
        width: imageFormats_logoImageFormats.width,
        height: imageFormats_logoImageFormats.height,
        src: logoOptimizedUrl,
        alt: "Customer Card"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_CustomerCard/* Row */.X, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
        size: "small",
        hover: isHover,
        variant: "mono",
        iconEnd: Common/* ChevronRightIcon */.XC,
        appearance: buttonAppearance,
        children: "Read their story"
      })
    })]
  }, index);
};

var List_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1npp3uw2"
} : 0)("margin:0 auto;display:none;column-gap:25px;width:100%;max-width:678px;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("md");
}, "{display:grid;grid-template:'item0 item0 item1' 250px '. . item1' 25px 'item2 item3 item1' 25px 'item2 item3 .' 25px 'item2 item3 item4' 250px 'item2 . item4' 25px/1fr 1fr 1fr;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("xl");
}, "{grid-template:'item0 item0' 250px '. .' 25px 'item2 item3' 300px 'item2 .' 25px/1fr 1fr;}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("xxl");
}, "{grid-template:'item0 item0 item1' 250px '. . item1' 25px 'item2 item3 item1' 25px 'item2 item3 .' 25px 'item2 item3 item4' 250px 'item2 . item4' 25px/1fr 1fr 1fr;}" + ( true ? "" : 0));

var List_Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1npp3uw1"
} : 0)( true ? {
  name: "i3nbfm",
  styles: "max-width:130px;width:auto;height:30px;margin:0"
} : 0);

var ItemWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_CustomerCard/* default */.Z,  true ? {
  target: "e1npp3uw0"
} : 0)("grid-area:", function (_ref11) {
  var area = _ref11.area;
  return area;
}, ";height:auto;", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("sm");
}, "{height:auto;}", function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.between("xl", "xl");
}, "{:nth-of-type(2){display:none;}:nth-of-type(5){display:none;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(75536);
// EXTERNAL MODULE: ../../node_modules/react-use/esm/useInterval.js
var useInterval = __webpack_require__(71926);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Hero/useMobileListCarousel.tsx







var useMobileListCarousel = function useMobileListCarousel(_ref) {
  var data = _ref.data;

  var position = function position(_ref2) {
    var min = _ref2.min,
        max = _ref2.max,
        value = _ref2.value;
    var rangeSize = max - min;
    return ((value - min) % rangeSize + rangeSize) % rangeSize + min;
  };

  var swipePower = function swipePower(offset, velocity) {
    return offset / velocity * 100;
  };

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var animation = (0,use_animation/* useAnimation */._)();
  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(0),
      page = _useState[0],
      setPage = _useState[1];

  var _useState2 = (0,react.useState)(false),
      drag = _useState2[0],
      setDrag = _useState2[1];

  var largeCardResolutionMediaQuery = theme.breakpoints.up("sm", false);
  var isLargeCardResolution = (0,useMatchMedia/* default */.Z)(largeCardResolutionMediaQuery, true);
  var isEnabledMediaQuery = theme.breakpoints.down("sm", false);
  var isEnabled = (0,useMatchMedia/* default */.Z)(isEnabledMediaQuery, true);
  var prevGhost = position({
    min: 0,
    max: data.length,
    value: page - 1
  });
  var prev = position({
    min: 0,
    max: data.length,
    value: page
  });
  var current = position({
    min: 0,
    max: data.length,
    value: page + 1
  });
  var next = position({
    min: 0,
    max: data.length,
    value: page + 2
  });
  var nextGhost = position({
    min: 0,
    max: data.length,
    value: page + 3
  });

  var handleDragEnd = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_e, _ref3) {
      var _ref$current$getBound, _ref$current;

      var offset, power;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              offset = _ref3.offset;
              power = swipePower(offset.x, (_ref$current$getBound = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().width) !== null && _ref$current$getBound !== void 0 ? _ref$current$getBound : 0);

              if (!(power > 60)) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return animation.start("toRight");

            case 5:
              paginate(-1);
              _context.next = 12;
              break;

            case 8:
              if (!(power < -60)) {
                _context.next = 12;
                break;
              }

              _context.next = 11;
              return animation.start("toLeft");

            case 11:
              paginate(1);

            case 12:
              setDrag(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDragEnd(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleDragStart = function handleDragStart() {
    setDrag(true);
  };

  (0,useInterval/* default */.Z)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return animation.start("toLeft");

          case 2:
            paginate(1);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), !isEnabled || drag ? null : 3000);

  var paginate = function paginate(dir) {
    setPage(page + dir);
  };

  return {
    handleDragStart: handleDragStart,
    handleDragEnd: handleDragEnd,
    isLargeCardResolution: isLargeCardResolution,
    items: {
      prevGhost: prevGhost,
      prev: prev,
      current: current,
      next: next,
      nextGhost: nextGhost
    },
    ref: ref,
    animation: animation,
    page: page
  };
};
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Hero/MobileListCarosuel.tsx




var _excluded = ["data", "active"];

function MobileListCarosuel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobileListCarosuel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileListCarosuel_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileListCarosuel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function MobileListCarosuel_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var MobileListCarousel = function MobileListCarousel(_ref) {
  var data = _ref.data;

  var _useMobileListCarouse = useMobileListCarousel({
    data: data
  }),
      page = _useMobileListCarouse.page,
      animation = _useMobileListCarouse.animation,
      ref = _useMobileListCarouse.ref,
      isLargeCardResolution = _useMobileListCarouse.isLargeCardResolution,
      handleDragEnd = _useMobileListCarouse.handleDragEnd,
      handleDragStart = _useMobileListCarouse.handleDragStart,
      items = _useMobileListCarouse.items;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileListCarosuel_Wrapper, {
    drag: "x",
    dragDirectionLock: true,
    dragConstraints: {
      left: 0,
      right: 0
    },
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    variants: {
      toLeft: {
        x: isLargeCardResolution ? "-368px" : "-308px",
        pointerEvents: "none"
      },
      toRight: {
        x: isLargeCardResolution ? "368px" : "308px",
        pointerEvents: "none"
      }
    },
    animate: animation,
    dragMomentum: false,
    transition: {
      x: {
        type: "spring",
        mass: 0.5,
        stiffness: 500,
        damping: 50
      }
    },
    children: [data[items.prevGhost] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Item, {
      data: data[items.prevGhost]
    }, "prevGhost-".concat(items.prevGhost)), data[items.prev] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Item, {
      data: data[items.prev]
    }, "prev-".concat(items.prev)), data[items.current] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Item, {
      ref: ref,
      active: true,
      data: data[items.current]
    }, "current-".concat(items.current)), data[items.next] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Item, {
      data: data[items.next]
    }, "next-".concat(items.next)), data[items.nextGhost] && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Item, {
      data: data[items.nextGhost]
    }, "nextGhost-".concat(items.nextGhost))]
  }, page);
};
var MobileListCarosuel_Item = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var _data$featuredLogo, _data$featuredLogo$fi, _useContentfulImage, _data$featuredImage, _data$featuredImage$f, _useContentfulImage2;

  var data = _ref2.data,
      active = _ref2.active,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var logoFile = data === null || data === void 0 ? void 0 : (_data$featuredLogo = data.featuredLogo) === null || _data$featuredLogo === void 0 ? void 0 : (_data$featuredLogo$fi = _data$featuredLogo.fields) === null || _data$featuredLogo$fi === void 0 ? void 0 : _data$featuredLogo$fi.file;

  var _ref3 = (_useContentfulImage = useContentfulImage_useContentfulImage(logoFile === null || logoFile === void 0 ? void 0 : logoFile.url, imageFormats_logoImageFormats)) !== null && _useContentfulImage !== void 0 ? _useContentfulImage : [],
      _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
      logoOptimizedUrl = _ref4[0];

  var imageFile = data === null || data === void 0 ? void 0 : (_data$featuredImage = data.featuredImage) === null || _data$featuredImage === void 0 ? void 0 : (_data$featuredImage$f = _data$featuredImage.fields) === null || _data$featuredImage$f === void 0 ? void 0 : _data$featuredImage$f.file;

  var _ref5 = (_useContentfulImage2 = useContentfulImage_useContentfulImage(imageFile === null || imageFile === void 0 ? void 0 : imageFile.url, featuredImageFormats)) !== null && _useContentfulImage2 !== void 0 ? _useContentfulImage2 : [],
      _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 1),
      featuredImageOptimizedUrl = _ref6[0];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledItem, MobileListCarosuel_objectSpread(MobileListCarosuel_objectSpread({
    ref: ref
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Cards, {
      tag: active ? "a" : "div",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/".concat(data.slug, "/"), pageConfig),
      img: featuredImageOptimizedUrl,
      hoverable: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_CustomerCard/* Row */.X, {
        children: logoOptimizedUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarosuel_Logo, {
          loader: function loader() {
            return logoOptimizedUrl;
          },
          width: imageFormats_logoImageFormats.width,
          height: imageFormats_logoImageFormats.height,
          src: logoOptimizedUrl,
          alt: "Customer Card"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_CustomerCard/* Row */.X, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          size: "small",
          variant: "mono",
          iconEnd: Common/* ChevronRightIcon */.XC,
          appearance: "dark",
          children: "Read their story"
        })
      })]
    })
  }));
});

var MobileListCarosuel_Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "eqebd9k3"
} : 0)( true ? {
  name: "i3nbfm",
  styles: "max-width:130px;width:auto;height:30px;margin:0"
} : 0);

var Cards = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_CustomerCard/* default */.Z,  true ? {
  target: "eqebd9k2"
} : 0)("height:100%;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("sm");
}, "{height:100%;}" + ( true ? "" : 0));

var MobileListCarosuel_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "eqebd9k1"
} : 0)("display:grid;grid-auto-flow:column;grid-auto-columns:min-content;gap:8px;margin-left:-600px;padding:0 24px;scrollbar-width:none;::-webkit-scrollbar{display:none;}", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("sm");
}, "{padding:0 40px;margin-left:-720px;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("md");
}, "{display:none;}" + ( true ? "" : 0));

var StyledItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eqebd9k0"
} : 0)("width:300px;height:246px;", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("sm");
}, "{width:360px;height:280px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var copy = {
  overline: "Customers",
  heading: "The most innovative companies choose Segment",
  description: "Tens of thousands of companies, including Intuit, FOX, IBM, and Levi\u2019s choose Twilio Segment to empower their teams with good data to make real-time decisions, accelerate growth and deliver world-class customer experiences.",
  filtersTitle: "Discover what you are looking for:",
  buttonText: "Get a demo"
};

var Hero = function Hero(_ref) {
  var data = _ref.data,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Background, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Wrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Copy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            variant: "h5",
            tag: "h1",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pExtraLarge",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDemoForm, {
            isProgressive: true,
            customFormIdentifier: "site-customers-demo",
            successMessageAppearance: "twilioLight"
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Featured, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
          data: data
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileListCarousel, {
          data: data
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FilterTitle, {
      variant: "pMedium",
      tag: "p",
      children: copy.filtersTitle
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters, {
      children: children
    })]
  });
};

var FilterTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10uy3ne7"
} : 0)( true ? {
  name: "1ur3dfm",
  styles: "text-align:center;margin-bottom:40px;margin-top:0"
} : 0);

var Filters = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10uy3ne6"
} : 0)("position:relative;z-index:1;width:100%;max-width:1040px;padding:0 24px;margin:0 auto 72px auto;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{padding:0 40px;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{margin-bottom:88px;}" + ( true ? "" : 0));

var StyledDemoForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DemoForm/* default */.Z,  true ? {
  target: "e10uy3ne5"
} : 0)("margin:40px auto 0;max-width:420px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{margin:40px 0 0;}" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e10uy3ne4"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{text-align:left;}" + ( true ? "" : 0));

var Background = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10uy3ne3"
} : 0)("justify-content:center;display:flex;flex-direction:column;background:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.neutrals.white[100];
}, ";border-radius:0px 0px 0px 80px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("xl");
}, "{border-radius:0px 0px 0px 150px;}" + ( true ? "" : 0));

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10uy3ne2"
} : 0)("display:grid;gap:55px;padding:40px 0 48px;grid-template-areas:'copy' 'featured';justify-content:center;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.up("sm");
}, "{padding:40px 0 54px;}", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.up("md");
}, "{padding:40px 40px 54px;}", function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.up("lg");
}, "{gap:80px;padding-bottom:88px;}", function (_ref11) {
  var theme = _ref11.theme;
  return theme.breakpoints.up("xl");
}, "{gap:120px;padding:80px 80px 88px;grid-template-columns:minmax(0%, 480px) minmax(0%, 444px);grid-template-areas:'copy featured';}", function (_ref12) {
  var theme = _ref12.theme;
  return theme.breakpoints.up("xxl");
}, "{padding-bottom:100px;padding-right:42px;grid-template-columns:minmax(0%, 560px) minmax(0%, 678px);gap:80px;}" + ( true ? "" : 0));

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10uy3ne1"
} : 0)("grid-area:copy;padding:0 24px;", function (_ref13) {
  var theme = _ref13.theme;
  return theme.breakpoints.up("sm");
}, "{padding:0 40px;}", function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.up("md");
}, "{padding:0;}" + ( true ? "" : 0));

var Featured = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10uy3ne0"
} : 0)( true ? {
  name: "126xgzz",
  styles: "grid-area:featured;overflow-x:hidden"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/components/Filter/Filter.tsx



function Filter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Filter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Filter_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Filter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var FilterSelect = function FilterSelect(_ref) {
  var options = _ref.options,
      id = _ref.id,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  var iconColor = appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      multiselect: true,
      mobileConfirmationBehaviour: true
    }
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Filter_Wrapper, {
    appearance: appearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, Filter_objectSpread(Filter_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small",
          color: iconColor
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {
        color: iconColor
      })
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    })), {}, {
      "aria-label": placeholder
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, Filter_objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

/* harmony default export */ var Filter = (FilterSelect);

var Filter_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nnjht30"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme,
      appearance = _ref2.appearance;
  return appearance === "dark" && theme.palette.brand.darkAcai[700];
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/data/useFilters.ts



function useFilters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFilters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFilters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFilters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useFilters = function useFilters(entries) {
  var _useState = (0,react.useState)(useFilters_objectSpread({}, entries.reduce(function (acc, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, []));
  }, {}))),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var createHandler = function createHandler(key, setState) {
    return function (selected) {
      return setState(function (prev) {
        return useFilters_objectSpread(useFilters_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, selected));
      });
    };
  };

  var selectHandlers = entries.reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
        key = _ref4[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, createHandler(key, setFiltersState)));
  }, {});
  return {
    filtersState: filtersState,
    selectHandlers: selectHandlers
  };
};
;// CONCATENATED MODULE: ./src/views/Customers/LandingPage/Customers.tsx




function Customers_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Customers_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Customers_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Customers_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Customers_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var toOptionProps = function toOptionProps(filter) {
  var id = filter.id,
      title = filter.title;
  return {
    value: id,
    text: title
  };
};

var useIntegrations = function useIntegrations(filtersState, triggerComponent) {
  var _data$pages$length;

  var _useCustomersQuery = (0,queries/* useCustomersQuery */.rq)({
    args: [{
      filters: filtersState
    }]
  }),
      data = _useCustomersQuery.data,
      isLoading = _useCustomersQuery.isLoading,
      hasNextPage = _useCustomersQuery.hasNextPage,
      fetchNextPage = _useCustomersQuery.fetchNextPage,
      error = _useCustomersQuery.error,
      isFetchingNextPage = _useCustomersQuery.isFetchingNextPage;

  var integrations = (0,react.useMemo)(function () {
    var _data$pages$flatMap, _data$pages;

    return (_data$pages$flatMap = data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.flatMap(function (collection) {
      var _collection$items;

      return (_collection$items = collection === null || collection === void 0 ? void 0 : collection.items) !== null && _collection$items !== void 0 ? _collection$items : [];
    })) !== null && _data$pages$flatMap !== void 0 ? _data$pages$flatMap : [];
  }, [data === null || data === void 0 ? void 0 : data.pages]);
  var nextPageTrigger = (0,useNextPageTrigger/* default */.Z)({
    isLoading: isLoading,
    totalDownloadedPages: (_data$pages$length = data === null || data === void 0 ? void 0 : data.pages.length) !== null && _data$pages$length !== void 0 ? _data$pages$length : -1,
    hasNextPage: hasNextPage,
    error: error,
    onNextPage: function onNextPage() {
      fetchNextPage();
    },
    loadMargin: "0%",
    NextPageTrigger: triggerComponent
  });
  return {
    integrations: integrations,
    isLoading: isLoading,
    nextPageTrigger: nextPageTrigger,
    isFetchingNextPage: isFetchingNextPage,
    hasNextPage: hasNextPage
  };
};

var CustomersView = function CustomersView(_ref2) {
  var filters = _ref2.filters,
      heroData = _ref2.heroData,
      metaData = _ref2.metaData;
  var groupedFilterEntries = Object.entries(filters);

  var _useFilters = useFilters(groupedFilterEntries),
      filtersState = _useFilters.filtersState,
      selectHandlers = _useFilters.selectHandlers;

  var _useIntegrations = useIntegrations(filtersState),
      integrations = _useIntegrations.integrations,
      isLoading = _useIntegrations.isLoading,
      nextPageTrigger = _useIntegrations.nextPageTrigger,
      isFetchingNextPage = _useIntegrations.isFetchingNextPage,
      hasNextPage = _useIntegrations.hasNextPage;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: metaData.socialTitle,
      pageDescription: metaData.socialDescription,
      pageOG: metaData.socialImage.fields.file.url,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {
          data: heroData.map(function (data) {
            var _data$matchaLogo;

            return Customers_objectSpread(Customers_objectSpread({}, data), {}, {
              featuredLogo: (_data$matchaLogo = data.matchaLogo) === null || _data$matchaLogo === void 0 ? void 0 : _data$matchaLogo.fields.logoMono
            });
          }),
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Customers_Filters, {
            children: groupedFilterEntries.map(function (_ref3) {
              var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
                  key = _ref4[0],
                  filter = _ref4[1];

              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filter, {
                options: filter.items.map(toOptionProps),
                id: key,
                onSelect: selectHandlers[key],
                placeholder: filter.title
              }, key);
            })
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Customers_Wrapper, {
          children: [!isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerCardsGrid_CustomerCardsGrid, {
            integrations: integrations
          }), isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
          }), hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
            compensateTopGutter: hasNextPage,
            children: isFetchingNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
          }), nextPageTrigger]
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1e87l0e3"
} : 0)("background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var Customers_Filters = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e87l0e2"
} : 0)("display:grid;row-gap:16px;column-gap:24px;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("md");
}, "{grid-auto-flow:column;}" + ( true ? "" : 0));

var Customers_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e87l0e1"
} : 0)( true ? {
  name: "i7c5k1",
  styles: "max-width:1084px;margin:auto"
} : 0);

var Customers_ref =  true ? {
  name: "ccki3e",
  styles: "padding:0;margin-top:-160px"
} : 0;

var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1e87l0e0"
} : 0)("display:grid;align-items:center;justify-content:center;height:400px;padding:80px 0;margin:0 auto;", function (_ref7) {
  var compensateTopGutter = _ref7.compensateTopGutter;
  return compensateTopGutter && Customers_ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var LandingPage_Customers = (CustomersView);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/customers/index.tsx





var Customers = function Customers(_ref) {
  var filters = _ref.filters,
      heroData = _ref.heroData,
      metaData = _ref.metaData;
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPage_Customers, {
      filters: filters,
      heroData: heroData,
      metaData: metaData
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var customers = (Customers);

/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 16046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useIntersectionObserver_useIntersectionObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/useIntersectionObserver.ts



var isRef = function isRef(ref) {
  return typeof ref !== "string";
};

var validSelector = function validSelector(slug) {
  var selector = slug.trim();

  if (selector && selector.match(/^\d/)) {
    selector = selector.replace(/^[0-9]+/, "");
    selector = selector.startsWith("-") ? selector.replace("-", "") : selector;
  }

  return selector;
};
/**
 * A hook to observe elements in the viewport
 * @param refs - An array of refs or selectors
 * @param callback - The function to call when an element is intersecting
 * @param options - The options for the IntersectionObserver
 * @returns An object containing the update function to update the observed elements and the observer reference
 */


var useIntersectionObserver = function useIntersectionObserver(refs, callback, options) {
  var observerRef = (0,react.useRef)();
  var currentlyObserved = (0,react.useRef)(Array.from({
    length: refs.length
  }).fill(null));

  var _useState = (0,react.useState)(0),
      updateCount = _useState[0],
      setUpdateCount = _useState[1];

  var callbackHandle = (0,useEventCallback/* default */.Z)(callback, []);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(callbackHandle, options);
    observerRef.current = intersectionObserver;
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (element && currentlyObserved.current) {
        intersectionObserver.observe(element);
        currentlyObserved.current[index] = element;
      }
    });
    return function () {
      intersectionObserver.disconnect();
      currentlyObserved.current = null;
    };
  }, [updateCount, callbackHandle]);
  var update = (0,react.useCallback)(function () {
    return setUpdateCount(function (state) {
      return ++state;
    });
  }, []); // Update observed element
  // JSX is changing and observed element can be mounted and unmounted from jsx tree
  // This effect takes care of updating currently observed element to newest reference value

  (0,react.useEffect)(function () {
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (observerRef.current && currentlyObserved.current) {
        var areDifferent = currentlyObserved.current[index] !== element;

        if (currentlyObserved.current[index] && areDifferent && isRef(ref)) {
          var _observerRef$current;

          (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.unobserve(currentlyObserved.current[index]);
          currentlyObserved.current[index] = null;
        }

        if (areDifferent && element && isRef(ref)) {
          var _observerRef$current2;

          (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 ? void 0 : _observerRef$current2.observe(element);
          currentlyObserved.current[index] = element;
        }
      }
    });
  });
  return {
    observerRef: observerRef,
    update: update
  };
};

/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = (useIntersectionObserver);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/index.ts


/***/ }),

/***/ 78299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useNextPageTrigger_useNextPageTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(16046);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/useNextPageTrigger.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




/**
 * A hook that triggers the next page when the element is in view.
 * @param props.isLoading Whether the next page is loading.
 * @param props.onNextPage The function to call when the next page should be loaded.
 * @param props.loadMargin The margin to use when loading the next page.
 * @param props.totalDownloadedPages The total number of downloaded pages.
 * @param props.hasNextPage Whether there is a next page.
 * @param props.error The error that occurred while loading the next page.
 * @param props.NextPageTrigger The component to render as the next page trigger.
 * @returns The React component to render as the next page trigger.
 */

var useNextPageTrigger = function useNextPageTrigger(_ref) {
  var isLoading = _ref.isLoading,
      onNextPage = _ref.onNextPage,
      loadMargin = _ref.loadMargin,
      pageLength = _ref.totalDownloadedPages,
      hasNextPage = _ref.hasNextPage,
      error = _ref.error,
      _ref$NextPageTrigger = _ref.NextPageTrigger,
      NextPageTrigger = _ref$NextPageTrigger === void 0 ? DefaultNextPageTrigger : _ref$NextPageTrigger;
  var nextPageTriggerRef = (0,react.useRef)(null);
  var isInView = (0,react.useRef)(false);
  (0,useIntersectionObserver/* default */.Z)([nextPageTriggerRef], function (intersections) {
    var isInViewValue = intersections.some(function (i) {
      return i.isIntersecting;
    });
    isInView.current = isInViewValue;

    if (isLoading) {
      return;
    }

    if (isInViewValue && hasNextPage) {
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    }
  }, {
    rootMargin: loadMargin,
    threshold: [1]
  });
  (0,react.useEffect)(function () {
    if (!isLoading && isInView.current && hasNextPage) {
      // eslint-disable-next-line no-warning-comments
      // TODO: This `onNextPage()` call should be revisited since it is fetching pagination data twice
      // check out on /customers, /recipes, /catalog, /growth-masters/curriculum
      // Maybe we should remove this useEffect entirely and refactor this hook.
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoading, pageLength, hasNextPage]); // Split it to simplify typescript compilation

  var El = NextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(El, {
    ref: nextPageTriggerRef,
    error: error
  });
};

/* harmony default export */ var useNextPageTrigger_useNextPageTrigger = (useNextPageTrigger);

var DefaultNextPageTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11u9tnv0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/index.ts


/***/ }),

/***/ 12877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers",
      function () {
        return __webpack_require__(26333);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8943,6234,4136,2073,6784,5735,2609,948,8187,3996,7947,7960,6012,6818,2472,1770,9774,2888,179], function() { return __webpack_exec__(12877); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);